// extracted by mini-css-extract-plugin
export var active = "_ko-e";
export var blink = "_ko-f";
export var dropDownSelector = "_ko-5";
export var dropDownWrapper = "_ko-4";
export var fakeCursor = "_ko-d";
export var fontSizeButton = "_ko-7";
export var formQuillEditor = "_ko-0";
export var pressed = "_ko-g";
export var qlBlank = "_ko-1";
export var textFormattingToolbar = "_ko-2";
export var textFormattingToolbarClosed = "_ko-3";
export var textFormattingToolbarInline = "_ko-6";
export var textToolbarOption = "_ko-8";
export var toolbarCell = "_ko-a";
export var toolbarCellCollapsed = "_ko-b";
export var toolbarOptionHitArea = "_ko-c";
export var toolbarOverflow = "_ko-9";